import ChangeLanguageButton from './ChangeLanguageButton';

export default ChangeLanguageButton;
